import { createApi } from './core';
import { CreateUpdateMarketRequest, Market, TimeslotAdjustmentLog, TimeslotAdjustmentReason, TimeslotAggregate } from './markets.types';

declare const healConfig: any;

function createMarketsApi() {
  return createApi({ baseURL: healConfig.apiBaseUrl + '/admin' });
}

export function fetchMarkets(): Promise<Market[]> {
  return createMarketsApi()
    .then((api) => api.get<any>('/markets'))
    .then((r) => (r.ok ? r.data.data : null));
}

export function createMarket(data: Partial<CreateUpdateMarketRequest>): Promise<Market> {
  return createMarketsApi()
    .then((api) => api.post<any>('/markets', data))
    .then((r) => (r.ok ? r.data.data : null));
}

export function updateMarket(data: Partial<CreateUpdateMarketRequest>): Promise<Market> {
  return createMarketsApi()
    .then((api) => api.put<any>('/markets', data))
    .then((r) => (r.ok ? r.data.data : null));
}

export function deleteMarket(market: string): Promise<boolean> {
  return createMarketsApi()
    .then((api) => api.delete<any>(`/markets/${market}`))
    .then((r) => r.ok);
}

export function fetchBuckets(market: string, services: string[], isoDate: string): Promise<TimeslotAggregate[]> {
  const params: any = {
    market,
    services: services.join(','),
    day: isoDate,
  };
  return createMarketsApi()
    .then((api) => api.get<any>('/timeslot/aggregate', params))
    .then((r) => (r.ok ? r.data : null));
}

export function updateBuckets(adjustmentReasonId: string, timeslots: { id: string; backorder: number }[]): Promise<boolean> {
  return createMarketsApi()
    .then((api) => api.put<any>('/timeslot/aggregate', { adjustmentReasonId, timeslots }))
    .then((r) => r.ok);
}

export function fetchBucketUpdateReasons(): Promise<TimeslotAdjustmentReason[]> {
  return createMarketsApi()
    .then((api) => api.get<any>('/timeslot/adjustmentReasons'))
    .then((r) => (r.ok ? r.data : null));
}

export function fetchBucketLogs(market: string, day: string): Promise<TimeslotAdjustmentLog[]> {
  return createMarketsApi()
    .then((api) => api.get<any>('/timeslot/logs', { market, day }))
    .then((r) => (r.ok ? r.data.data : null));
}
